export default __webpack_public_path__ + "static/media/CNo.48-5.cf74a9c0.jpg";